import React from 'react'
import "../../styles/s_machine.css"
import Prodcard1 from '../../components/prodcards/Prodcard'
import sasm from '../../img/sasm.png'
import asm from '../../img/asm.png'

const S_machine = () => {
  const des= {
    sasm: ['max strap - size not stipulated','min strap size - 60*30','strapping speed - 1.5','strap width -  6-15','strap force - 450','height - 750/500','weight - 90','power source - 220v,50hz,1/4hp','dimension - 900*580*750/500',
      ],
      asm:['POWER SUPPLY-110V/220V/240V (1PH)','PACKING SIZE- (MAX-500*500MM MIN-150*135*130)','TAPE WIDTH-50MM OR 76MM','WORKING TABLE HEIGHT-570~770MM ADJUSTABLE','SEALING CAPACITY-20 ARTONS PER MIN','DIMENSION-1373*900*1375MM',
        ]

  }

  return (
    <div className='prdmain'>
      <div className='head2'>
        <h1>Strapping Machine</h1>
      </div>
      <div className='items1'>
        <Prodcard1
          imageSrc={sasm}
          model={"101 H"}
          title="Semi Automatic Strapping Machine"
          altText="img of websit"
          description={des.sasm}
        />
         <Prodcard1
          imageSrc={asm}
          model={"VP 102PL"}
          title="Automatic Taping & Strapping Machine"
          altText="img of websit"
          description={des.asm}
        />

      </div>


    </div>
  )
}

export default S_machine